import { render, staticRenderFns } from "./VacancyInfo.vue?vue&type=template&id=f6627b32&"
import script from "./VacancyInfo.vue?vue&type=script&lang=js&"
export * from "./VacancyInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports